import { SearchStatus } from '../features/search/Results/components/multiSeller/storeCard/Enums'
import BaseServiceProvider from './BaseServiceProvider'
import { MultiSellerSpecificCondition } from '../api/part/interface'

export type SellerCartFields = 'poNumber' | 'noteToStore'

export interface ISeller {
  id: number
  serviceDealerId: number
  storeName: string
  coverageId: number
  coverageKey: string
  isPrimary: boolean
  regionId: number
  regionName: string
  customerNumber: string
  sellPartnerId: string
  supEntityId: number
  sellerName: string
  mailAddress: string
  mailCity: string
  mailState: string
  mailPostalCode: string
  mailCountryCode: string
  mailCountry: string
  contactName: string
  emailAddress: string
  phone: string
  status: boolean
  sequence: number
  logoUrl: string
}

export interface IStoreCard extends ISeller {
  totalParts: number
  searchStatus: SearchStatus
  isMyPlaceStore: boolean
  selected: boolean
  specificConditions?: MultiSellerSpecificCondition[]
  msPartsBinId?: string
}

type SellerResponse = ISeller[]

class MultiSellerServiceProvider extends BaseServiceProvider {
  constructor() {
    super(import.meta.env.VITE_API_BASE_URL, 'multiseller', '1.1', '')
  }

  getSellers = async (): Promise<SellerResponse> => {
    const resp = await this.get<SellerResponse>('getSellers')
    return resp.data
  }

  getActiveSellers = async (): Promise<SellerResponse> => {
    const sellers = await this.getSellers()
    return sellers.filter((seller) => seller.status === true)
  }
}

export default new MultiSellerServiceProvider()
